import { render, staticRenderFns } from "./AiQuizBanner.vue?vue&type=template&id=4d364e05&scoped=true&"
import script from "./AiQuizBanner.vue?vue&type=script&lang=js&"
export * from "./AiQuizBanner.vue?vue&type=script&lang=js&"
import style0 from "./AiQuizBanner.vue?vue&type=style&index=0&id=4d364e05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d364e05",
  null
  
)

export default component.exports